module.exports = __webpack_public_path__ + "img/oleh-dankevych.34f34e82.webp";